const randArt = {
  assistance: {
    title: 'Auswahlhilfe',
    img: {
      src: require('../../../../../assets/img/icons/infoSelection.svg'),
      alt: 'Information Auswahl'
    },
    headingTop: 'Beispiel Seite a:',
    headingBottom: 'Hinweise:',
    desc: {
      hint1: 'Die Randgestaltungsart "Schnittkante" ist anfangs für alle Seiten vorausgewählt',
      hint2: 'Klicken Sie auf eine nicht markierte Seite um die Randgestaltungsart für diese Seite zu ändern'
    }
  },
  schnittkante: {
    title: {
      name: 'Schnittkante',
      code: 'R01'
    },
    subtitle: 'Seiten:',
    desc: {
      toggle: 'kub-beschreibung-schnittkante',
      title: 'Beschreibung',
      text: 'Ist keine Randgestaltung wie z.B. Saum, Hohlsaum, Keder, usw. gewünscht, wird die Plane nur geschnitten (= Schnittkante). Dies ist z.B. dann der Fall, wenn die Plane zur Befestigung zwischen zwei Profilen oder Hölzern geklemmt wird.'
    }
  },
  saum: {
    titleSaum: {
      name: 'Saum',
      code: 'R02'
    },
    price: null,
    subtitleSaum: 'Seiten:',
    desc: {
      toggle: 'kub-beschreibung-saum',
      title: 'Beschreibung',
      text: 'Als Saum wird ein verstärkter Rand bezeichnet. Hierbei wird das Planenmaterial um ca. 4&nbsp;cm nach hinten umgeschlagen und verschweißt. Die Schweißnaht befindet sich auf der Rückseite der Skizze / Draufsicht. In diesem ca. 4&nbsp;cm breiten Streifen werden – falls gewünscht – die Ösen angebracht.</br></br><strong>Hinweis:</strong> Der Saum wird von uns automatisch berücksichtigt. Die von Ihnen angegebene Abmessung entspricht der tatsächlichen Größe der Plane.'
    },
    titleOesen: 'Ösen',
    subtitleOesenart: 'Art:',
    subtitleOesenanzahl: 'Anzahl',
    subtitleOesenabstand: 'Abstand',
    modalOesenabstand: {
      img: {
        src: require('../../../../../assets/img/icons/oesenabstand.svg'),
        alt: 'Oesenabstand'
      },
      desc: 'Der Ösenabstand beschreibt die Distanz der Mittelpunkte zweier benachbarter Ösen.'
    },
    optionsOesenart: [
      { value: { oesenArt: 'keine Ösen', code: 'O01', price: null, drehverschluss: false }, text: '' },
      {
        label: 'Rundöse',
        options: [
          { value: { oesenArt: 'Rundöse, Stahl/verzinkt, Ø 12 mm', code: 'O02', price: null, drehverschluss: false }, text: '' },
          { value: { oesenArt: 'Rundöse, Stahl/verzinkt, Ø 16 mm', code: 'O03', price: null, drehverschluss: false }, text: '' },
          { value: { oesenArt: 'Rundöse, Stahl/verzinkt, Ø 20 mm', code: 'O04', price: null, drehverschluss: false }, text: '' },
          { value: { oesenArt: 'Rundöse, Stahl/verzinkt, Ø 25 mm', code: 'O05', price: null, drehverschluss: false }, text: '' },
          { value: { oesenArt: 'Rundöse, rostfrei, Nirosta, Ø 16 mm', code: 'O06', price: null, drehverschluss: false }, text: '' }
        ]
      },
      {
        label: 'Ovalöse',
        options: [
          { value: { oesenArt: 'Ovalöse, Messing/vernickelt, Ø 22.5mm x 13.5mm', code: 'O07', price: null, drehverschluss: true }, text: '' },
          { value: { oesenArt: 'Ovalöse, Stahl/verzinkt, Ø 42mm x 22mm', code: 'O08', price: null, drehverschluss: true }, text: '' },
          { value: { oesenArt: 'Ovalöse, rostfrei, Nirosta, Ø 22.5mm x 13.5mm', code: 'O09', price: null, drehverschluss: true }, text: '' }
        ]
      }
    ],
    subtitleDrehverschluss: 'Inkl. dazugehöriger Drehverschlüsse',
    optionsDrehverschluss: [
      { value: { art: 'mit Drehverschlüssen', code: 'D01', factor: null }, text: 'ja' },
      { value: { art: 'ohne Drehverschlüsse', code: 'D02', factor: null }, text: 'nein' }
    ]
  },
  hohlsaum: {
    title: {
      name: 'Hohlsaum',
      code: 'R03'
    },
    subtitleHohlsaum: 'Seiten:',
    subtitleBreiteHohlsaum: 'Breite:',
    desc: {
      toggle: 'kub-beschreibung-hohlsaum',
      title: 'Beschreibung',
      text: 'Bei einem Hohlsaum wird der umgeschlagene Rand nicht flächig verklebt oder verschweißt (Schweißnaht befindet sich auf der Rückseite der Skizze / Draufsicht), es verbleibt also ein Hohlraum. In diesen Hohlraum kann dann z.B. ein Profil, ein Rundrohr oder eine Holzlatte geschoben werden, um die Plane zu befestigen oder zu beschweren.</br></br> Die Größe des Hohlsaums wird in cm angegeben und flach gemessen. D.h., der Hohlsaum für z.B. ein 1&Prime;-Rohr muss mindestens 4&nbsp;cm flach gemessen sein (Rohrdurchmesser 1&Prime; = 2,54&nbsp;cm &rarr; 7,98&nbsp;cm Umfang &rarr; 3,99&nbsp;cm halber Umfang = Mindestmaß Hohlsaum).</br></br><strong>Hinweis:</strong> Bei der Maßangabe muss der Hohlsaum nicht berücksichtigt werden. Die von Ihnen angegebene Abmessung entspricht der tatsächlichen Größe der Plane.'
    },
    optionsBreiteHohlsaum: [
      { value: { breite: '4 cm', code: 'H01', price: null }, text: '' },
      { value: { breite: '6 cm', code: 'H02', price: null }, text: '' },
      { value: { breite: '8 cm', code: 'H03', price: null }, text: '' },
      { value: { breite: '10 cm', code: 'H04', price: null }, text: '' },
      { value: { breite: '12 cm', code: 'H05', price: null }, text: '' },
      { value: { breite: '14 cm', code: 'H06', price: null }, text: '' },
      { value: { breite: '16 cm', code: 'H07', price: null }, text: '' },
      { value: { breite: '18 cm', code: 'H08', price: null }, text: '' },
      { value: { breite: '20 cm', code: 'H09', price: null }, text: '' }
    ]
  },
  keder: {
    title: {
      name: 'Keder',
      code: 'R04'
    },
    subtitleKeder: 'Seiten:',
    subtitleKederGroesse: 'Größe:',
    desc: {
      toggle: 'kub-beschreibung-keder',
      title: 'Beschreibung',
      text: 'Bei einem Keder handelt es sich um ein Rundprofil mit einer (meist doppelten) „Fahne“, das in eine Kederschiene seitlich eingeführt werden kann. Der Keder wird mit der/den Fahne/n an der Plane befestigt (meistens verschweißt).</br></br> Jeder Wohnwagen hat auf der Türseite eine durchgängige Kederschiene, an der eine Plane oder eine Markise mit Keder als Sonnen- oder Regenschutz befestigt werden kann. Bei der Kederschiene handelt es sich im Querschnitt um eine runde Führungsnut, in die der Keder der Plane/Markise längs eingebracht und verschoben werden kann.</br></br> Auch im Zeltbau wird viel mit Keder gearbeitet, da sich damit Planen quer zur Kantenlinie flächig spannen lassen.</br></br><strong>Hinweis:</strong> Bei der Maßangabe muss das Kedermaß nicht berücksichtigt werden. Die von Ihnen angegebenen Maße sind Endmaße, also von Außenkante zu Außenkante inkl. Keder.'
    },
    optionsKederGroesse: [
      { value: { art: 'weiß, Ø 5,5 mm', code: 'K01', price: null }, text: '' },
      { value: { art: 'weiß, Ø 7,5 mm', code: 'K02', price: null }, text: '' },
      { value: { art: 'weiß, Ø 8,5 mm', code: 'K03', price: null }, text: '' }
    ]
  },
  hohlschnitt: {
    title: {
      name: 'Hohlschnitt',
      code: 'R05'
    },
    subtitleHohlschnitt: 'Alle Seiten:',
    desc: {
      toggle: 'kub-beschreibung-hohlschnitt',
      title: 'Beschreibung',
      text: 'Ein Hohlschnitt wird z.B. bei der Fertigung hochwertiger Sonnensegel angewendet. Hierbei wird das meistens rechteckig oder dreieckig geformte Sonnensegel an den Rändern nicht gerade, sondern in einem leichten Bogen geschnitten. In den Saum des Segels wird ein Gurtband eingenäht, das an den Ecken jeweils mit einem D-Ring zur Befestigung versehen wird. Beim Aufhängen des Segels wird dieses nur an den Ecken aufgenommen und gut verspannt. Der Zug auf das leicht gebogene Gurtband versucht dieses „gerade“ zu ziehen und sorgt dadurch für eine gute flächige Spannung des Segels.'
    },
    optionsHohlschnitt: [
      { value: true, text: 'ja' },
      { value: false, text: 'nein' }
    ],
    factor: null
  }
}

export default {
  randArt
}
